import React from 'react'
//import { ConnectedRouter } from 'connected-react-router'
import { BrowserRouter } from 'react-router-dom'
import { Switch } from 'react-router'
//import history from '../../history'
import routerConfiguration from '../../configuration/routing'
import routerHome from '../../home/routing'
import routerError from '../../error-page/routing'
import routerInactive from '../../inactive-page/routing'
import routerRedirectToRoute from './redirect-to-route/routing'
import routerConfigurator from '../../configurator/routing'
import routerStock from '../../stock/routing'
import routerTradeIn from '../../trade-in/routing'
import router404 from '../../no-match-route/routing'
import routerTheming from '../../theming/routing'

const Router = () => (
  <BrowserRouter>
    <Switch>
      {routerRedirectToRoute}
      {routerHome}
      {routerError}
      {routerInactive}
      {routerConfigurator}
      {routerStock}
      {routerTradeIn}
      {routerTheming}
      {routerConfiguration}
      {router404}
    </Switch>
  </BrowserRouter>
)

export default Router
